import { useTranslate } from '@tolgee/react'
import { AllocationRulesDrawerHeader } from '../../../atoms/AllocationRules/AllocationRulesDrawerHeader'

interface Props {
  onCreateNewRule: () => void
  onImportFromLibrary: () => void
}
export const GlobalRulesDrawerHeader = ({ onCreateNewRule, onImportFromLibrary }: Props) => {
  const { t } = useTranslate()

  return (
    <AllocationRulesDrawerHeader
      title={t('globalRules', 'Global Rules')}
      onCreateNewRule={onCreateNewRule}
      onImportFromLibrary={onImportFromLibrary}
    />
  )
}
